import { GET_ALL_COMPANIES } from 'src/api/graphql/queries/companies.gql';
import { GET_ALL_WORTHS } from 'src/api/graphql/queries/worths.gql';
import { GET_ALL_OBJECTIONS } from 'src/api/graphql/queries/objections.gql';
import { COMPANY_MENU_FILTERS_BY_KEY } from 'src/utils/data/company-statuses';
import { fetchList } from './fetchLists';
import { buildCompanyTypeFilters } from './getAllCompanies';

const COMPANY_TYPES = {
	commission: { salesTarget: 'COMMISSION' },
	abonent: { salesTarget: 'ABONENT' },
};

const STATUS_KEYS = [
	'take',
	'delay',
	'contact',
	'inwork',
	'victory',
	'loss',
	'all',
];

const fetchCompanyCount = async (types, statusKey) => {
	const filters = {
		...buildCompanyTypeFilters(types),
		...(COMPANY_MENU_FILTERS_BY_KEY[statusKey] || {}),
	};

	const { pagination } = await fetchList({
		query: GET_ALL_COMPANIES,
		variables: {
			page: 1,
			limit: 1,
			filters,
		},
	});

	return pagination?.totalCount ?? 0;
};

const fetchWorthCount = async (required) => {
	const variables = {
		page: 1,
		limit: 1,
		...(required === true || required === false
			? { filters: { required: { eq: required } } }
			: {}),
	};

	const { pagination } = await fetchList({
		query: GET_ALL_WORTHS,
		variables,
	});

	return pagination?.totalCount ?? 0;
};

const fetchObjectionsCount = async () => {
	const { pagination } = await fetchList({
		query: GET_ALL_OBJECTIONS,
		variables: {
			page: 1,
			limit: 1,
		},
	});

	return pagination?.totalCount ?? 0;
};

export const getMenuCounts = async () => {
	const countPromises = [];

	for (const [prefix, types] of Object.entries(COMPANY_TYPES)) {
		for (const statusKey of STATUS_KEYS) {
			countPromises.push(
				fetchCompanyCount(types, statusKey).then((count) => [
					`${prefix}_${statusKey}`,
					count,
				]),
			);
		}
	}

	countPromises.push(
		fetchWorthCount(true).then((count) => ['worth_required', count]),
		fetchWorthCount(false).then((count) => ['worth_rated', count]),
		fetchWorthCount(undefined).then((count) => ['worth_all', count]),
		fetchObjectionsCount().then((count) => ['objection', count]),
	);

	const entries = await Promise.all(countPromises);

	return Object.fromEntries(entries);
};
